import React from 'react'
import { Col, Row } from 'reactstrap'
import SeatSelection from '../../booking/seats/SeatSelection'
import RideBookingSelectedSeats from './RideBookingSelectedSeats'

const RideBookingSeatSelection = () => (
  <Row>
    <Col md={6}>
      <SeatSelection isRideBooking />
    </Col>
    <Col md={6} className="mx-auto">
      <RideBookingSelectedSeats />
    </Col>
  </Row>
)

export default RideBookingSeatSelection
